import ReactJson, { ReactJsonViewProps } from 'react-json-view';

export const JsonViewer = (props: ReactJsonViewProps) => {
  return (
    <ReactJson
      style={{ padding: '1rem' }}
      theme="rjv-default"
      iconStyle="triangle"
      enableClipboard={true}
      displayDataTypes={false}
      displayObjectSize={false}
      indentWidth={4}
      collapsed={false}
      collapseStringsAfterLength={100}
      {...props}
    />
  );
};
